import { BroadcastChannel } from "broadcast-channel";
import React from "react";
import styled, { css } from "styled-components";

import { SuccessIcon } from "../components/icons/CustomIcons";
import { OnboardingContainer } from "../components/login/OnboardingElements";
import { Flex } from "../hex-components/Flex";
import { Txt } from "../hex-components/Txt";
import { BROADCAST_CHANNEL_NAMES } from "../hooks/useListenToBroadcastChannnel";
import { useOnInitialMount } from "../hooks/useOnInitialMount";
import { useQueryParams } from "../route/routes";

const StyledFlex = styled(Flex).attrs({
  align: "center",
  direction: "column",
  justify: "center",
})`
  width: 100%;
  height: 100%;
  text-align: center;
`;

const BigSuccessIcon = styled(SuccessIcon)`
  transform: translateY(2px);
  color: ${({ theme }) => theme.intent.SUCCESS};

  svg {
    width: 64px;
    height: 64px;
  }
`;

const ErrorView = React.memo(function ErrorView({ error }: { error: string }) {
  return <StyledFlex>{error}</StyledFlex>;
});

const SuccessView = React.memo(function SuccessView({
  mcpServerConnectionId,
}: {
  mcpServerConnectionId: string;
}) {
  useOnInitialMount(async () => {
    const mcpServerOauthEvents = new BroadcastChannel(
      BROADCAST_CHANNEL_NAMES.MCP_OAUTH_CALLBACK,
    );
    await mcpServerOauthEvents.postMessage(mcpServerConnectionId);
    await mcpServerOauthEvents.close();

    window.setTimeout(() => {
      window.close();
    }, 1500);
  });

  return (
    <StyledFlex>
      <BigSuccessIcon />
      <Txt fontSize="extra_large" fontWeight="semi_bold" renderAs="h1">
        Successfully connected
      </Txt>
      <Txt fontColor="muted">This window will close automatically.</Txt>
    </StyledFlex>
  );
});

export const McpServerOauthResultView = React.memo(
  function McpServerOauthResultView() {
    const queryParams = useQueryParams();

    const error =
      queryParams.get("error") ??
      "An error occurred while connecting to the MCP server";
    const mcpServerConnectionId = queryParams.get("mcpServerConnectionId");

    return (
      <OnboardingContainer
        css={css`
          width: 100%;
          height: 100%;
        `}
      >
        {mcpServerConnectionId ? (
          <SuccessView mcpServerConnectionId={mcpServerConnectionId} />
        ) : (
          <ErrorView error={error} />
        )}
      </OnboardingContainer>
    );
  },
);
